import React from 'react';
import { Check, FileText, Calendar, MessageSquare } from 'lucide-react';
export function WhatsIncluded() {
  return <section className="py-20 bg-gradient-to-b from-white to-pink-50 px-4" data-id="element-237">
      <div className="max-w-5xl mx-auto" data-id="element-238">
        <div className="text-center mb-12" data-id="element-239">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6" data-id="element-240">
            Lo que incluye el PDF{' '}
            <span className="text-pink-600" data-id="element-241">(sin relleno)</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-242">
          {/* Main Card */}
          <div className="bg-white p-8 rounded-3xl shadow-xl border border-gray-100" data-id="element-243">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-244">
              <FileText className="w-6 h-6 text-pink-500 mr-3" data-id="element-245" />
              Guiones Listos
            </h3>
            <ul className="space-y-4" data-id="element-246">
              <li className="flex items-start" data-id="element-247">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-248" />
                <span className="text-gray-700 text-lg" data-id="element-249">
                  Tienda / Drive‑thru / Restaurante
                </span>
              </li>
              <li className="flex items-start" data-id="element-250">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-251" />
                <span className="text-gray-700 text-lg" data-id="element-252">
                  Llamadas (escuela, doctor, servicios)
                </span>
              </li>
              <li className="flex items-start" data-id="element-253">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-254" />
                <span className="text-gray-700 text-lg" data-id="element-255">
                  Trabajo (aclarar, pedir tiempo, sonar profesional)
                </span>
              </li>
            </ul>
          </div>

          {/* Secondary Card */}
          <div className="bg-white p-8 rounded-3xl shadow-xl border border-gray-100" data-id="element-256">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-257">
              <MessageSquare className="w-6 h-6 text-orange-500 mr-3" data-id="element-258" />
              Herramientas de Rescate
            </h3>
            <ul className="space-y-4" data-id="element-259">
              <li className="flex items-start" data-id="element-260">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-261" />
                <span className="text-gray-700 text-lg font-bold" data-id="element-262">
                  12 Frases Rescate
                </span>
                <span className="text-gray-500 text-sm ml-2 mt-1" data-id="element-263">
                  (para pedir repetición, ganar tiempo)
                </span>
              </li>
              <li className="flex items-start" data-id="element-264">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-265" />
                <span className="text-gray-700 text-lg" data-id="element-266">
                  Plan de 7 días (calendario simple)
                </span>
              </li>
              <li className="flex items-start" data-id="element-267">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-268" />
                <span className="text-gray-700 text-lg" data-id="element-269">
                  Mini‑retos para practicar sin vergüenza
                </span>
              </li>
              <li className="flex items-start" data-id="element-270">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-271" />
                <span className="text-gray-700 text-lg" data-id="element-272">Hojas imprimibles</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}